import { createTheme } from "@mui/material/styles";

const lightTheme = createTheme({
  direction: "ltr", // Default direction
  palette: {
    mode: "light",
    primary: {
      main: "#2A4B50", // New Primary Color
    },
    secondary: {
      main: "#1AA98B", // New Secondary Color
    },
    background: {
      default: "#ffffff", // Light Blue (Water)
      paper: "#ffffff", // White
    },
    text: {
      primary: "#2A4B50", // New Primary Color
      secondary: "#1AA98B", // New Secondary Color
      white: "#fff", // New Secondary Color
      red: "red",
    },
  },
  typography: {
    fontFamily: ({ theme }) =>
      theme.direction === "rtl"
        ? ' "Calibri", sans-serif'
        : ' "Calibri", sans-serif',
    h1: {
      fontSize: "2.5rem",
      fontWeight: 500,
    },
    h2: {
      fontSize: "2rem",
      fontWeight: 500,
    },
    h3: {
      fontSize: "1.75rem",
      fontWeight: 500,
    },
    h4: {
      fontSize: "1.5rem",
      fontWeight: 500,
    },
    h5: {
      fontSize: "1.25rem",
      fontWeight: 500,
    },
    h6: {
      fontSize: "1rem",
      fontWeight: 500,
    },
    body1: {
      fontSize: "1rem",
    },
    body2: {
      fontSize: "0.875rem",
    },
  },
  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: "containedWhite" }, // New variant
          style: {
            backgroundColor: "#ffffff",
            color: "#6366f1",
            "&:hover": {
              backgroundColor: "#f8f8f8",
            },
          },
        },
        {
          props: { variant: "containedGreen" }, // New variant
          style: {
            textTransform: "none",
            background: "linear-gradient(45deg, #2A4B50 30%, #1AA98B 90%)",
            color: "#ffffff", // White
            transition: "transform 0.2s ease-in-out",
            marginLeft: ({ theme }) =>
              theme.direction === "rtl" ? "0" : "8px",
            marginRight: ({ theme }) =>
              theme.direction === "rtl" ? "8px" : "0",
            "&:hover": {
              background: "linear-gradient(45deg, #223D42 30%, #178A72 90%)",
              transform: "scale(1.05)",
            },
          },
        },
      ],
      styleOverrides: {
        root: {
          textTransform: "none",
          transition: "transform 0.2s ease-in-out",
          marginLeft: ({ theme }) => (theme.direction === "rtl" ? "0" : "8px"),
          marginRight: ({ theme }) => (theme.direction === "rtl" ? "8px" : "0"),
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: "linear-gradient(45deg, #2A4B50 1000%)",
          color: "#ffffff", // White
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#ffff", // Light Blue (Water)
          color: "#2A4B50", // New Primary Color
          left: ({ theme }) => (theme.direction === "rtl" ? "auto" : 0),
          right: ({ theme }) => (theme.direction === "rtl" ? 0 : "auto"),
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: "#2A4B50", // New Primary Color
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#ffffff", // White
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          backgroundColor: "#1AA98B", // New Primary Color
          color: "#ffffff", // White
        },
      },
    },
  },
});

export default lightTheme;
